module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.UserIds),
      expression: "UserIds"
    }],
    domProps: {
      "value": (_vm.UserIds)
    },
    on: {
      "change": _vm.update,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.UserIds = $event.target.value
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-10ab46fc"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/component/ct-adc-user-id-textarea.vue
// module id = 48
// module chunks = 0